import { Link } from 'react-router-dom';

/**
 * Home rhythm (layout report move #10): the one large-type statement on the
 * page. The line is built from the home intro copy ("we measure first ...
 * then adjust with light, precise contacts. No cracking or twisting."), no
 * new claims. A small heading sits in the left margin on desktop, above the
 * line on phones.
 */
export default function HomeStatement() {
  return (
    <section className="ve-section ve-home-statement" aria-labelledby="home-statement-title">
      <div className="ve-container ve-container--wide ve-home-statement-grid">
        <h2 id="home-statement-title" className="ve-home-statement-label">
          Our approach
        </h2>
        <div className="ve-home-statement-body">
          <p className="ve-home-statement-text">
            We measure first, then adjust with light, precise contacts. <span>No cracking or twisting.</span>
          </p>
          <Link to="/our-techniques/" className="ve-home-statement-link">
            How we measure and adjust
          </Link>
        </div>
      </div>
    </section>
  );
}
